import global from "./global";
import { combineReducers } from '@reduxjs/toolkit';

export default combineReducers({
    global
})